import React from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { FIELDSET } from '../itemIds';
import styled from 'styled-components';
import { useEditorStore } from '~/shell/Store';
import LightButton from '~/editor/buttons/LightButton';

export const FieldSetElement = styled.fieldset`
  width: 100%;
  position: -webkit-sticky;
`;

interface Props {
  title: string;
  children?: [];
}

export type FieldsetDefinition = ItemDefinition<typeof FIELDSET, Props>;

export class Fieldset extends Item<typeof FIELDSET, Props> {
  protected render({ title, children }: RenderProps<Props>) {
    const { contentEditable, sequence, addSubItem } = useEditorStore();

    const AddNewItem = () => {
      const currentSequence = useEditorStore.getState().sequence;
      const question = currentSequence!.items.find(
        (item: { id: string; type: string }) => item.type === 'QUESTION'
      );

      if (question && question.items && question.items.length > 0) {
        const lastItem = question.items[question.items.length - 1];

        if (lastItem) {
          const newItem = {
            ...lastItem,
            id: `${Date.now()}`,
            position: question.items.length + 1
          };
          newItem.value = 'Type Here';
          newItem.title = 'Type Here';

          addSubItem({
            sequenceId: sequence!.id,
            data: {
              type: newItem.type,
              title: newItem.value,
              value: newItem.value,
              position: question.items.length + 1,
              correct: newItem.correct,
              parent_id: question.id,
              feedback: '',
              subvalue: newItem.subvalue
            },
            newItem: newItem
          });
        }
      }
    };

    return (
      <FieldSetElement style={contentEditable ? { padding: '0px' } : {}}>
        <legend className="sr-only" aria-label={title}>
          {title}
        </legend>
        {children}
        {contentEditable && (
          <LightButton
            style={{
              marginTop: '20px',
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
            onClick={AddNewItem}
          >
            Add Answer
          </LightButton>
        )}
      </FieldSetElement>
    );
  }
}

registry[FIELDSET] = Fieldset;
